import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PermissionEnum, PermissionDenied, IconLoader } from '@ui/src';
import { useAppSelector } from '@store';
import Header from '../../components/user-roles/header/header';
import ROUTES from '../../routes';
import {
  useLazyGetEmployeesBaseDictionariesQuery,
  useLazyGetActiveCurrenciesQuery,
  useLazyGetAdministrationCountriesQuery,
  useLazyGetEmployeesDictionariesQuery,
} from '../../store/dictionaries/service';
import Columns from './columns';
import { useLazyGetRoleValidatorsQuery } from './store/services/roles';
import { useLazyGetNotificationsTemplatesQuery } from '../notification-settings/store/services';

import cn from './styles.module.css';

const UserRoles = () => {
  const navigate = useNavigate();

  const {
    administrationDictionaries: {
      activePermissions,
      roles,
      countries,
      activeCurrencies,
      users,
    },
    notificationSettings: {
      templates: { templates },
    },
  } = useAppSelector((state) => state);

  const [getEmployeesBaseDictionaries] =
    useLazyGetEmployeesBaseDictionariesQuery();
  const [getActiveCurrencies] = useLazyGetActiveCurrenciesQuery();
  const [getEmployeesCountries] = useLazyGetAdministrationCountriesQuery();
  const [getEmployeesDictionaries] = useLazyGetEmployeesDictionariesQuery();
  const [getValidators] = useLazyGetRoleValidatorsQuery();
  const [getNotificationTemplates] = useLazyGetNotificationsTemplatesQuery();

  useEffect(() => {
    if (
      !templates &&
      activePermissions?.includes(
        PermissionEnum.NOTIFICATIONS_TYPES_TEMPLATE_LIST,
      )
    ) {
      getNotificationTemplates();
    }
  }, [templates, activePermissions]);

  useEffect(() => {
    if (activePermissions?.includes(PermissionEnum.USERS_ROLES_LIST)) {
      if (!roles) {
        getEmployeesBaseDictionaries();
      }

      if (!activeCurrencies) {
        getActiveCurrencies();
      }

      if (!countries) {
        getEmployeesCountries();
      }

      getValidators();

      if (activePermissions.includes(PermissionEnum.USERS_LIST) && !users) {
        getEmployeesDictionaries();
      }
    }
  }, [activePermissions, roles, activeCurrencies, countries, users]);

  useEffect(() => {
    let title = 'Empoyees Roles';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.rolesLoader}>
      <IconLoader />
    </div>
  );

  if (activePermissions) {
    if (
      !activePermissions.includes(PermissionEnum.SECTION_ADMINISTRATION) ||
      !activePermissions.includes(PermissionEnum.USERS_ROLES_LIST)
    ) {
      content = <PermissionDenied />;
    } else {
      content = (
        <div className={cn.roles}>
          <Header
            onClick={
              activePermissions?.includes(
                PermissionEnum.USERS_ROLES_CREATE_ACTION,
              )
                ? () => navigate(ROUTES.ROLE_ADD)
                : undefined
            }
          />
          <div className={cn.columns}>
            <Columns />
          </div>
        </div>
      );
    }
  }

  return content;
};

export default UserRoles;
